/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum InvestmentWorkflowType {
    JOINER_CREATE = 'JOINER_CREATE',
    JOINER = 'JOINER',
    ALLOCATION = 'ALLOCATION',
    LEAVER = 'LEAVER',
}
